import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL } from "@/data/categories";

export default function SiteFooter() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between">
          <div className="max-w-md">
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-table-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">{t("brand")}</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">{t("footer.disclaimer")}</p>
          </div>

          <div className="flex flex-col gap-4 sm:text-right">
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:self-end"
            >
              {t("nav.buyNow")}
              <i className="ri-arrow-right-up-line text-sm" />
            </a>
            <div className="flex flex-wrap justify-start gap-x-5 gap-y-2 sm:justify-end">
              {["footer.about", "footer.contact", "footer.privacy", "footer.terms", "footer.editorial", "footer.updates"].map(
                (key) => (
                  <span key={key} className="whitespace-nowrap text-sm text-foreground-500">
                    {t(key)}
                  </span>
                ),
              )}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-2 border-t border-background-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-sm text-foreground-500">
            © {year} {t("brand")}. {t("footer.rights")}
          </p>
          <p className="text-xs text-foreground-400">{t("hero.badge")}</p>
        </div>
      </div>
    </footer>
  );
}